import { motion, useAnimation } from "framer-motion";
import {
  KeyboardShortcutOptions,
  useKeyboardShortcuts,
} from "../../../hooks/keyboard-event-hooks";
import { IpisButton, IpisButtonProps } from "@ipis/client-essentials";

interface Props {
  className?: string;
  buttonProps: Omit<IpisButtonProps, "sublabel">;
  keyboardShortcut: Omit<KeyboardShortcutOptions, "callback">;
}

const KeyboardShortcutAppButton = (props: Props) => {
  const animControls = useAnimation();

  useKeyboardShortcuts({
    ...props.keyboardShortcut,
    callback: () => {
      animControls.start({
        opacity: [1, 0.5, 1],
        transition: { duration: 0.75 },
      });
      props.buttonProps.onClick?.();
    },
  });

  let keyboardShortcutText = "";
  if (props.keyboardShortcut.ctrlKey) {
    keyboardShortcutText += "Ctrl + ";
  }
  if (props.keyboardShortcut.altKey) {
    keyboardShortcutText += "Alt + ";
  }
  if (props.keyboardShortcut.shiftKey) {
    keyboardShortcutText += "Shift + ";
  }
  keyboardShortcutText += props.keyboardShortcut.key;

  return (
    <motion.div animate={animControls} className={props.className}>
      <IpisButton {...props.buttonProps} sublabel={keyboardShortcutText} />
    </motion.div>
  );
};

export default KeyboardShortcutAppButton;
